import { render, staticRenderFns } from "./estPage.vue?vue&type=template&id=2a95cf14&"
import script from "./estPage.vue?vue&type=script&lang=js&"
export * from "./estPage.vue?vue&type=script&lang=js&"
import style0 from "./estPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports